<template>
  <tr>
    <td>{{ item.created_at }}</td>
    <td>{{ item.trust_balance }}</td>
    <td>{{ item.balance }}</td>
    <td>{{ item.difference }}</td>
    <td><div :class="`status status-color-${item.status}`" />{{ getStatus(item.status) }}</td>
  </tr>
</template>

<script>
export default {
  name: 'UserTrustPointsItem',
  props: {
    item: {
      created_at: '',
      trust_balance: '',
      balance: '',
      difference: '',
      status: ''
    }
  },
  methods: {
    getStatus (status) {
      if (status === 1)
        return 'Отказано'
      if (status === 2)
        return 'Принято'
      if (status === 0)
        return 'В процессе'
    }
  }
}
</script>

<style scoped>
.status {
  display: inline-block;
  margin-right: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.status-color-1 {
  background: red;
}

.status-color-2 {
  background: green;
}

.status-color-0 {
  background: yellow;
}
</style>
